(function () {
  const initSection = (section) => {
    const id = section.getAttribute("id");
    const swiperEl = section.querySelector(`.images-with-text__slider`);

    const image_width = swiperEl.dataset.imagewidth;
    const large_image = image_width == "large";
    const carousel_type = swiperEl.dataset.carouseltype;
    const slide = carousel_type == "slide";
    const speed = swiperEl.dataset.speed * 1000;
    const slidesCount = swiperEl.dataset.realSlides;

    const slides_per_view = large_image ? 1.95 : 3.2;
    const gap = slide ? 24 : 4;

    if (slidesCount < 5 && slidesCount > 2 && !slide) {
      const wrapper = swiperEl.querySelector(".swiper-wrapper");
      const slides = [...wrapper.querySelectorAll(".swiper-slide")];

      wrapper.innerHTML += wrapper.innerHTML;
    }

    const imagesWithTextSwiper = new Swiper(`#${id} .swiper`, {
      loop: true,
      slidesPerView: large_image ? 1.9 : 2.2,
      spaceBetween: gap,
      speed: speed,
      spaceBetween: slide ? 8 : 4,
      allowTouchMove: true,
      breakpoints: {
        990: {
          slidesPerView: slides_per_view,
          spaceBetween: gap,
        },
      },
      autoplay: slide
        ? true
        : {
            delay: 0,
          },
      freeMode: {
        enabled: true,
        momentum: false,
      },
      on: {
        init() {
          this.slides.forEach((slide, i) => {
            const isFocusable = i < parseInt(swiperEl.dataset.realSlides);
            slide.toggleAttribute("tabindex", isFocusable);
            slide.classList.toggle("focus-inset", isFocusable);
          });
        },
      },
    });

    if (section.querySelector(".preFade") != null) {
      const animatedElements = section.querySelectorAll(".preFade");

      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("fadeIn");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0,
        }
      );

      animatedElements.forEach((el) => observer.observe(el));
    }
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
